import React from 'react';

export interface StepConfig {
    key: string;
    label: string;
    icon?: React.ReactNode;
}

interface StepIndicatorProps {
    steps: StepConfig[];
    currentIndex: number;
}

const getStepClasses = (index: number, currentIndex: number): string => {
    if (index < currentIndex) {
        return 'bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-300';
    }
    if (index === currentIndex) {
        return 'bg-blue-600 text-white';
    }
    return 'bg-gray-100 text-gray-400 dark:bg-slate-700 dark:text-gray-500';
};

const StepIndicator: React.FC<StepIndicatorProps> = ({ steps, currentIndex }) => (
    <div className="flex gap-1">
        {steps.map((s, i) => (
            <div
                key={s.key}
                className={`flex-1 flex items-center justify-center gap-2 py-2 text-sm rounded-lg ${getStepClasses(i, currentIndex)}`}
            >
                {s.icon} {s.label}
            </div>
        ))}
    </div>
);

export default StepIndicator;
